/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button, Space, Tag, Typography } from 'antd';
import { PlusOutlined, StopOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import PlantingLifecycleTag from '../../../../features/plantings/components/PlantingLifecycleTag';
import LocationBreadcrumb from '../../../../features/plantings/components/LocationBreadcrumb';
import { styles } from '../styles';

const { Title, Text } = Typography;

interface Props {
  planting: any;
  currentLocation: any;
  onActionClick: () => void;
  onDispositionClick: () => void;
  projectedQuantity?: number | null;
}

const TERMINAL_STATUSES = new Set(['sold', 'dead', 'archived', 'transferred']);

const PlantingHeaderCard: React.FC<Props> = ({
  planting,
  currentLocation,
  onActionClick,
  onDispositionClick,
  projectedQuantity,
}) => (
  <Space direction="vertical" size={8} css={{ width: '100%' }}>
    <Space css={styles.headerFlex}>
      <Space>
        <Title level={3} css={styles.noMargin}>
          {planting.crop?.name || 'Посадка'}
        </Title>
        <PlantingLifecycleTag status={planting.lifecycleStatus} />
        {planting.quantity && planting.quantity > 1 && (
          <Tag color="blue" css={styles.quantityTag}>× {planting.quantity} шт</Tag>
        )}
        {projectedQuantity != null && planting.quantity > 1 && projectedQuantity < planting.quantity && (
          <Tag color="volcano" css={styles.quantityTag}>
            ⚠ прогноз: {projectedQuantity} шт
          </Tag>
        )}
      </Space>
      <Space>
        <Button type="primary" icon={<PlusOutlined />} onClick={onActionClick}>
          Действие
        </Button>
        {!TERMINAL_STATUSES.has(String(planting.lifecycleStatus || '')) && (
          <Button icon={<StopOutlined />} onClick={onDispositionClick}>
            Выбытие
          </Button>
        )}
      </Space>
    </Space>

    {planting.crop?.latinName && (
      <Text type="secondary" italic>{planting.crop.latinName}</Text>
    )}

    <div css={styles.locationRow}>
      <LocationBreadcrumb
        location={currentLocation}
        locationContext={planting.locationContext}
        linkable
      />
    </div>

    {planting.quantity && planting.quantity > 1 && (
      <Text type="secondary">
        Групповая посадка: {planting.quantity} растений
        {projectedQuantity != null && projectedQuantity < planting.quantity && (
          <Text type="danger"> · симуляция: выжило {projectedQuantity} из {planting.quantity}</Text>
        )}
      </Text>
    )}

    {planting.createdAt && (
      <Text type="secondary" css={styles.smallText}>
        Создана: {dayjs(planting.createdAt).format('DD.MM.YYYY')}
      </Text>
    )}
  </Space>
);

export default PlantingHeaderCard;
